import React from 'react'
// eslint-disable-next-line react/no-deprecated
import { createRoot } from 'react-dom/client'
import App from './App'
import { Provider } from 'react-redux'
import store from './store'
import { BrowserRouter as Router } from 'react-router-dom'
// store is global state
// actions
const container = document.getElementById('shop-app')

const root = createRoot(container)
root.render(
  <Provider store={store}>
    <Router >
      <App />
    </Router>
  </Provider>
)
